import { useLinkCardForm } from "@/components/shared/forms/link-card-form";
import type { CommonColor } from "@stackje/common/config";

export function AddLinkCard(
  defaultType: "link1" | "link2" | "link3" | "link4" | "link5" | "link6",
  defaultColors: CommonColor
) {
  const { formContent, previewContent, toggleType, shuffleColors, handleSubmit } =
    useLinkCardForm({
      initialData: {
        title: "",
        description: "",
        links: [],
        type: defaultType,
        colors: defaultColors,
      },
      mode: "add",
    });

  return {
    formContent,
    previewContent,
    toggleType,
    shuffleColors,
    handleSubmit,
  };
}
